// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a6a1d81b","496":"ad87ef89","574":"142b5a0b","576":"d8ac6dda","780":"0e2ebb2f","854":"f5e53f66","875":"7d6890ac"}[chunkId] + ".chunk.js";
};